import { Card, PageContainer, Skeleton } from '@/components/ui'

export default function AddressesLoading() {
  return (
    <PageContainer top="header-gap" bottom="chrome" className="flex flex-col gap-4" aria-busy>
      {[1, 2].map((index) => (
        <Card key={index} className="flex items-center justify-between gap-4">
          <div className="flex flex-1 flex-col gap-2">
            <Skeleton className="w-3/4" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-3 w-2/3" />
          </div>
          <Skeleton shape="circle" className="h-8 w-8" />
        </Card>
      ))}
    </PageContainer>
  )
}
